"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSLegendSection = void 0;
const ui_1 = require("@app/component/ui");
const icon_1 = require("@app/component/ui/icon");
const util_1 = require("@app/util");
const react_1 = __importDefault(require("react"));
const uuid_1 = require("uuid");
const icoIsIcon = (t) => typeof t === 'string';
const _legends = [
    {
        ico: 'warning',
        label: 'warning',
    },
    {
        ico: (react_1.default.createElement(ui_1.Text, { color: 'primary', type: 'body-large', weight: 'bold' }, "X/Y")),
        label: 'offer',
    },
    {
        ico: 'exchange',
        label: 'transfer',
    },
    {
        ico: 'phone-plus',
        label: 'emergency',
    },
    {
        ico: 'phone',
        label: 'standBy',
    },
    {
        ico: 'comment',
        label: 'note',
    },
    {
        ico: 'checkboxes',
        label: 'agenda',
    },
    {
        ico: 'save',
        label: 'attributes',
    },
    {
        ico: 'attachment',
        label: 'attachment',
    },
];
const CSLegendSection = () => {
    const legends = react_1.default.useRef(_legends.map((legend) => ({
        id: (0, uuid_1.v4)(),
        ico: legend.ico,
        label: (0, util_1.t)(`CALENDAR_SETTINGS_LEGEND.${legend.label}`),
    })));
    return (react_1.default.createElement("div", { style: { padding: '0.75rem' } },
        react_1.default.createElement("div", { style: {
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                gap: '0.5rem',
                paddingBottom: '0.5rem',
                boxSizing: 'border-box',
            } },
            react_1.default.createElement(ui_1.Text, { type: ui_1.Text.TYPES.BODY_LARGE, weight: ui_1.Text.WEIGHTS.BOLD }, (0, util_1.t)('CALENDAR_SETTINGS_LEGEND.title')),
            react_1.default.createElement(ui_1.Spacing, { size: ui_1.Spacing.SIZES.SIZE_16, type: ui_1.Spacing.TYPES.VERTICAL }),
            legends.current.map((legend) => (react_1.default.createElement("div", { key: legend.id, style: { display: 'flex', gap: '0.5rem', alignItems: 'center' } },
                react_1.default.createElement(react_1.default.Fragment, null,
                    icoIsIcon(legend.ico) ? (react_1.default.createElement(icon_1.Icon, { color: icon_1.Icon.COLORS.PRIMARY, ico: legend.ico })) : (legend.ico),
                    react_1.default.createElement(ui_1.Text, { type: ui_1.Text.TYPES.BODY_MEDIUM, weight: ui_1.Text.WEIGHTS.BOLD }, legend.label))))))));
};
exports.CSLegendSection = CSLegendSection;
